"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Segment = void 0;
var getSegment = function () {
    // Get the typed window
    var win = window;
    // Create a queue, but don't obliterate an existing one!
    var analytics = win.analytics = win.analytics || [];
    // If the real analytics.js is already on the page return.
    if (analytics.initialize) {
        return analytics;
    }
    // If the snippet was invoked already show an error.
    if (analytics.invoked) {
        if (console && console.error) {
            console.error("Segment snippet included twice.");
        }
        return;
    }
    /*
     * Invoked flag, to make sure the snippet
     * is never invoked twice.
     */
    analytics.invoked = true;
    // A list of the methods in Analytics.js to stub.
    analytics.methods = [
        "trackSubmit",
        "trackClick",
        "trackLink",
        "trackForm",
        "pageview",
        "identify",
        "reset",
        "group",
        "track",
        "ready",
        "alias",
        "debug",
        "page",
        "once",
        "off",
        "on"
    ];
    /*
     * Define a factory to create stubs. These are placeholders
     * for methods in Analytics.js so that you never have to wait
     * for it to load to actually record data. The `method` is
     * stored as the first argument, so we can replay the data.
     */
    analytics.factory = function (method) { return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var newArgs = Array.prototype.slice.call(args);
        newArgs.unshift(method);
        analytics.push(newArgs);
        return analytics;
    }; };
    // For each of our methods, generate a queueing stub.
    for (var i = 0; i < analytics.methods.length; i++) {
        var key = analytics.methods[i];
        analytics[key] = analytics.factory(key);
    }
    /*
     * Define a method to load Analytics.js from our CDN,
     * and that will be sure to only ever load it once.
     */
    analytics.load = function (key) {
        // Mark this is not ready yet
        analytics.IS_IT_NOT_READY = true;
        // Create an async script element based on your key.
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = ("https:" === document.location.protocol ? "https://" : "http://") + "cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";
        // Insert our script next to the first script element.
        var scripts = document.getElementsByTagName("script");
        if (!scripts || scripts.length < 1) {
            throw new Error("[PinpoWebFramework] Segment: Unable to locate any script balise to insert the Segment's one");
        }
        var first = scripts[0];
        // Check that first as a parentElement
        if (!first.parentNode) {
            throw new Error("[PinpoWebFramework] Segment: The first script balise hasn't any parent element");
        }
        first.parentNode.insertBefore(script, first);
    };
    // Add a version to keep track of what's in the wild.
    analytics.SNIPPET_VERSION = "4.0.0";
    return analytics;
};
getSegment();
var Segment = { analytics: function () { return window.analytics; } };
exports.Segment = Segment;
//# sourceMappingURL=Segment.js.map